<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>
<!-- Main content Start -->
<div class="main-content">
  <!-- Breadcrumbs Start -->
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/6.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color padding">
      <h1 class="page-title">Contact</h1>
      <ul>
        <li>
          <a class="active" href="index.html">Home</a>
        </li>
        <li>Contact</li>
      </ul>
    </div>
  </div>
  <!-- Breadcrumbs End -->
  <!-- Contact Section Start -->
  <div class="contact-page-section pt-100 pb-100 md-pt-70 md-pb-70">
    <div class="container">
      <div class="row rs-contact-box mb-90 md-mb-50">
        <div class="col-lg-4 col-md-12-4 lg-pl-0 sm-mb-30 md-mb-30">
          <div class="address-item">
            <div class="icon-part">
              <img src="assets/images/contact/icon/1.png" alt="">
            </div>
           
            <div class="address-text">
              <span class="label">Address</span>
              <div class="des"> Sri Sai Degree &amp; P.G College,</div>
              <div class="des">Near Market Yard, R S Road, Gooty,</div>
              <div class="des">Anantapuramu - 515 401,</div>
              <div class="des">
                Andhra Pradesh, India.
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-12 lg-pl-0 sm-mb-30 md-mb-30">
          <div class="address-item">
            <div class="icon-part">
              <img src="assets/images/contact/icon/2.png" alt="">
            </div>
            <div class="address-text">
              <span class="label">Email Address</span>
              <div class="des"><a href="mailto:ssdcgty@gmail.com">ssdcgty@gmail.com</a></div>
               </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-12 lg-pl-0 sm-mb-30">
          <div class="address-item">
            <div class="icon-part">
              <img src="assets/images/contact/icon/3.png" alt="">
            </div>
            <div class="address-text">
              <span class="label">Phone Number</span>
              <div class="des"><a href="tel:+91- 9014219371">+91- 9014219371</a></div>
              
            </div>
          </div>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-lg-6 md-mb-30">
          <!-- Map Section Start -->
          <div class="map-img">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3851.5259535917758!2d77.6306058!3d15.129433200000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb69440a7d84a49%3A0xdb5b95a4a48965bd!2sSri%20Sai%20Degree%20College!5e0!3m2!1sen!2sin!4v1777136404654!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
        </div>
        <div class="col-lg-6 pl-60 md-pl-15">
          <div class="contact-comment-box">
            <div class="inner-part">
              <h2 class="title mb-mb-15">Sri Sai Degree &amp; P.G College</h2>
              <p>Get In Touch</p>
            </div>
            <div id="form-messages"></div>

            
              <form [formGroup]="contactUsForm" (ngSubmit)="onSubmit()">
                <div class="row">
                  <div class="col-lg-6 mb-35 col-md-12">
                    <input type="text" class="form-control" placeholder="Enter First Name" formControlName="firstName">
                    <div *ngIf="isFieldValid('firstName')" class="alert alert-danger">
                      Enter a valid first name
                    </div>
                  </div>
                  <div class="col-lg-6 mb-35 col-md-12">
                    <input type="text" class="form-control" placeholder="Enter Last Name" formControlName="lastName">
                    <div *ngIf="isFieldValid('lastName')" class="alert alert-danger">
                      Enter a valid last name
                    </div>
                  </div>
                  <div class="col-lg-6 mb-35 col-md-12">
                    <input type="text" class="form-control" placeholder=" Enter Guest Mail Address"
                           formControlName="emailAddress">
                    <div *ngIf="isFieldValid('emailAddress')" class="alert alert-danger">
                      Enter Valid Email Address
                    </div>
                  </div>
                  <div class="col-lg-6 mb-35 col-md-12">
                    <input class="form-control" placeholder="Phone Number"
                           formControlName="phoneNumber">
                    <div *ngIf="isFieldValid('phoneNumber')" class="alert alert-danger">
                      Enter a valid 10-digit number
                    </div>
                  </div>


                  <div class="col-lg-12 mb-50">
                    <textarea class="from-control" id="message" name="message" placeholder=" Message" formControlName="message"></textarea>
                  </div>
                </div>
                <div class="form-group mb-0">
                  <button
                    class="btn-send"
                    type="submit"
                    [disabled]="!contactUsForm.valid || isLoad"
                    [attr.aria-busy]="isLoad"
                  >
                    <span *ngIf="isLoad" class="btn-spinner" aria-hidden="true"></span>
                    {{ isLoad ? 'Submitting...' : 'Submit Now' }}
                  </button>
                </div>
              </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Contact Section End -->
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->

